<div class="cockpit-edit-container">
	<div class="header">
		<span class="title">{{ labels.lbl_ckp_gerenciar_ckp }}</span>
		<div class="button-container" *ngIf="!isLoadingLabels && !isLoadingAvailableCharts && !isLoadingAvailableCustomCharts">
			<div class="button" (click)="openModalEvaluationMSP()">{{ labels.lbl_geral_avaliar }} MySupport</div>
			<a class="button" (click)="onBackClick()">{{ labels.lbl_geral_voltar }}</a>
		</div>
	</div>

	<div class="body" *ngIf="!isLoadingLabels && !isLoadingAvailableCharts && !isLoadingAvailableCustomCharts">
		<span class="group-header">{{ labels.lbl_ckp_add_indicator }}</span>
		<div class="group-body">
			<cpi-input-with-autocomplete
				[availableOptions]="availableChartsIAC"
				[placeholder]="labels.lbl_geral_selecione"
				[minInputLength]="0"
				[inputHeight]="'30px'"
				[unselectValue]="unselectValue"
				(onValueChange)="getChart($event)">
			</cpi-input-with-autocomplete>

			<div
				class="example-container"
				*ngIf="
					((selectedChart && selectedChart.length > 0) || (selectedCard && selectedCard.length > 0)) && !isLoadingSelectedChart
				">
				<span class="label">{{ labels.lbl_ckp_indicadores_selecionados }}</span>
				<pcp-cockpit-chart
					[cockpitCards]="selectedCard"
					[cockpitCharts]="selectedChart"
					[config]="{ hideDelete: true }"
					[labels]="labels">
				</pcp-cockpit-chart>
			</div>

			<div
				class="example-container"
				*ngIf="
					(!selectedChart || selectedChart.length === 0) &&
					(!selectedCard || selectedCard.length === 0) &&
					!isLoadingSelectedChart
				">
				<span class="label no-margin">{{ labels.lbl_ckp_selecione_indicator_visualizar }}</span>
			</div>

			<div class="example-container" *ngIf="isLoadingSelectedChart">
				<cpi-dot-bounce-loading-effect [color]="'var(--gray-2)'"></cpi-dot-bounce-loading-effect>
			</div>

			<div class="button-container mt-3" *ngIf="!isLoadingSelectedChart && action !== ''">
				<div
					class="button big"
					[ngClass]="{ disabled: isExecutingAction || isResetingCockpit }"
					(click)="addChart()"
					*ngIf="action === 'add'">
					<span>{{ labels.lbl_geral_adicionar }}</span>
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isExecutingAction"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>

		<!-- Inicio Novo -->
		<span class="group-header" *ngIf="!hideCustomCockpit">{{ labels.lbl_geral_adicionar_novo_indicador_personalizado }}</span>
		<div class="group-body" *ngIf="!hideCustomCockpit">
			<cpi-input-with-autocomplete
				[availableOptions]="availableCustomChartsIAC"
				[placeholder]="labels.lbl_geral_selecione"
				[minInputLength]="0"
				[inputHeight]="'30px'"
				[unselectValue]="unselectValueCustom"
				(onValueChange)="getCustomChart($event)">
			</cpi-input-with-autocomplete>

			<div
				class="example-container"
				*ngIf="
					((selectedCustomChart && selectedCustomChart.length > 0) || (selectedCustomCard && selectedCustomCard.length > 0)) &&
					!isLoadingSelectedCustomChart
				">
				<span class="label">{{ labels.lbl_ckp_indicadores_selecionados }}</span>
				<pcp-cockpit-chart
					[cockpitCards]="selectedCustomCard"
					[cockpitCharts]="selectedCustomChart"
					[config]="{ hideDelete: true }"
					[labels]="labels">
				</pcp-cockpit-chart>
			</div>

			<div
				class="example-container"
				*ngIf="
					(!selectedCustomChart || selectedCustomChart.length === 0) &&
					(!selectedCustomCard || selectedCustomCard.length === 0) &&
					!isLoadingSelectedCustomChart
				">
				<span class="label no-margin">{{ labels.lbl_ckp_selecione_indicator_visualizar }}</span>
			</div>

			<div class="example-container" *ngIf="isLoadingSelectedCustomChart">
				<cpi-dot-bounce-loading-effect [color]="'var(--gray-2)'"></cpi-dot-bounce-loading-effect>
			</div>

			<div class="button-container mt-3" *ngIf="!isLoadingSelectedCustomChart && actionCustom !== ''">
				<div
					class="button big"
					[ngClass]="{ disabled: isExecutingCustomAction || isResetingCustomCockpit }"
					(click)="addCustomChart()"
					*ngIf="actionCustom === 'add'">
					<span>{{ labels.lbl_geral_adicionar }}</span>
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isExecutingCustomAction"></cpi-dot-bounce-loading-effect>
				</div>
			</div>

			<div class="dotted-input-container mt-3">
				<span class="label">{{ labels.lbl_geral_painel_gerenciamento_indicadores_customizados }}</span>
				<div class="button" (click)="showCustomManage = !showCustomManage">
					<span>{{ labels.lbl_security_gerenciar }}</span>
				</div>
			</div>
		</div>
		<!-- Fim Novo -->

		<div class="body" *ngIf="showCustomManage">
			<span class="group-header">{{ labels.lbl_geral_criar_novo_indicador }}</span>
			<div class="group-body">
				<div class="dotted-input-container">
					<span class="label no-margin">{{ labels.lbl_geral_nome_do_indicador }}*</span>
					<input type="text" placeholder="{{ labels.lbl_geral_nome_do_indicador }}" [(ngModel)]="selectedIndicatorName" />
				</div>

				<div class="dotted-input-container">
					<span class="label no-margin">{{ labels.lbl_geral_tipo_de_grafico }}*</span>
					<cpi-input-with-autocomplete
						[availableOptions]="listChartTypeIAC"
						[minInputLength]="0"
						[inputHeight]="'30px'"
						[placeholder]="labels.lbl_geral_selecione"
						[cleanValues]="clearValuesChartType"
						(onValueChange)="getChartType($event)">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<!-- <div class="dotted-input-container" *ngIf="chartType === 'bar' || chartType === 'pie'"> -->
					<span class="label no-margin">{{ labels.lbl_formato_grafico }}*</span>
					<cpi-input-with-autocomplete
						[availableOptions]="listChartParamValueIAC"
						[minInputLength]="0"
						[inputHeight]="'30px'"
						[placeholder]="labels.lbl_geral_selecione"
						[cleanValues]="clearValuesChartParamValue"
						(onValueChange)="getChartParamValue($event)">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<span class="label no-margin">{{ labels.lbl_geral_opcoes_de_coluna }}*</span>
					<cpi-input-with-autocomplete
						[availableOptions]="listRequestOptionsIAC"
						[minInputLength]="0"
						[inputHeight]="'30px'"
						[placeholder]="labels.lbl_geral_selecione"
						[cleanValues]="clearValuesRequestOptions"
						(onValueChange)="getRequestOption($event)">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<span class="label no-margin">{{ labels.lbl_geral_nome_de_exibicao }}*</span>
					<cpi-input-with-autocomplete
						[availableOptions]="listLabelsIAC"
						[minInputLength]="0"
						[inputHeight]="'30px'"
						[placeholder]="labels.lbl_geral_selecione"
						[cleanValues]="clearValuesLabel"
						(onValueChange)="getLabelName($event)">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<span class="label no-margin">{{ labels.lbl_geral_periodo }}*</span>
					<select [(ngModel)]="interval" (ngModelChange)="changeInterval($event)">
						<option [value]="null">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="-1">{{ labels.lbl_ultimos_30_dias }}</option>
						<option [value]="-3">{{ labels.lbl_ultimos_3_meses }}</option>
						<option [value]="-6">{{ labels.lbl_ultimos_6_meses }}</option>
						<option [value]="-12">{{ labels.lbl_ultimos_12_meses }}</option>
					</select>
				</div>

				<div class="dotted-input-container mt-3 button-right">
					<div class="button" (click)="showCustomManage = !showCustomManage">
						<span>{{ labels.lbl_geral_voltar }}</span>
					</div>
					<div class="button" (click)="postCustomIndicator()">
						<span>{{ labels.lbl_geral_salvar }}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="body" *ngIf="showCustomManage">
			<span class="group-header">{{ labels.lbl_geral_deletar_indicador }}</span>
			<div class="group-body">
				<div class="dotted-input-container">
					<span class="label no-margin">{{ labels.lbl_geral_nome_do_indicador }}</span>
					<cpi-input-with-autocomplete
						[availableOptions]="listIndicatorCustomIAC"
						[minInputLength]="0"
						[inputHeight]="'30px'"
						[placeholder]="labels.lbl_geral_selecione"
						[cleanValues]="clearValuesIndicatorCustom"
						(onValueChange)="getIdIndicator($event)">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container mt-3 button-right">
					<div class="button" (click)="showCustomManage = !showCustomManage">
						<span>{{ labels.lbl_geral_voltar }}</span>
					</div>
					<div class="button" (click)="handleDeleteClick()">
						<span>{{ labels.lbl_geral_excluir }}</span>
					</div>
				</div>
			</div>
		</div>

		<ng-container *ngIf="myCockpit && myCockpit.length > 0">
			<div class="group-header">{{ labels.lbl_ckp_ordenar_indicadores }}</div>
			<div class="group-body">
				<div class="drag-n-drop-container" (mousemove)="moveGhost($event)" (mouseleave)="dragndrop.isSelecting = false">
					<div
						class="item"
						*ngFor="let item of myCockpit; let index = index"
						(mousedown)="holdCockpitItem(item, index)"
						(mouseup)="reorderCockpit()"
						(mouseover)="moveSelectedItem(index)">
						<span>{{ labels[item.label] ? labels[item.label] : item.name }}</span>
						<div class="icon-buttons">
							<span
								class="icon-button delete"
								(click)="deleteChartFromList(item.id, index); $event.stopPropagation()"
								title="Remover"
								><fa-icon [icon]="icons.faTrash"></fa-icon
							></span>
							<span class="icon-button"><fa-icon [icon]="icons.faBars"></fa-icon></span>
						</div>
					</div>

					<div
						class="item ghost"
						[ngStyle]="{ top: dragndrop.y + 'px', left: dragndrop.x + 'px' }"
						*ngIf="dragndrop.isSelecting && dragndrop.selectedItem">
						{{ labels[dragndrop.selectedItem.label] ? labels[dragndrop.selectedItem.label] : dragndrop.selectedItem.name }}
					</div>
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="myCustomCockpit && myCustomCockpit.length > 0">
			<div class="group-header">{{ labels.lbl_ckp_ordenar_indicadores }}</div>
			<div class="group-body">
				<div class="drag-n-drop-container" (mousemove)="moveGhost($event)" (mouseleave)="dragndrop.isSelecting = false">
					<div
						class="item"
						*ngFor="let item of myCustomCockpit; let index = index"
						(mousedown)="holdCockpitItem(item, index)"
						(mouseup)="reorderCustomCockpit()"
						(mouseover)="moveSelectedItem(index)">
						<span>{{ labels[item.label] ? labels[item.label] : item.name }}</span>
						<div class="icon-buttons">
							<span
								class="icon-button delete"
								(click)="deleteCustomChartFromList(item.id, index); $event.stopPropagation()"
								title="Remover"
								><fa-icon [icon]="icons.faTrash"></fa-icon
							></span>
							<span class="icon-button"><fa-icon [icon]="icons.faBars"></fa-icon></span>
						</div>
					</div>

					<div
						class="item ghost"
						[ngStyle]="{ top: dragndrop.y + 'px', left: dragndrop.x + 'px' }"
						*ngIf="dragndrop.isSelecting && dragndrop.selectedItem">
						{{ labels[dragndrop.selectedItem.label] ? labels[dragndrop.selectedItem.label] : dragndrop.selectedItem.name }}
					</div>
				</div>
			</div>
		</ng-container>

		<div class="group-header">{{ labels.lbl_chat_analyst_configuracoes }}</div>
		<div class="group-body">
			<div class="dotted-input-container">
				<span class="label no-margin">{{ labels.lbl_geral_cliente_padrao }}</span>
				<input disabled [value]="ProfileService.userData().customer" />
			</div>

			<div class="dotted-input-container">
				<span class="label no-margin">{{ labels.lbl_geral_usuario }}</span>
				<input disabled [value]="ProfileService.userData().fullName" />
			</div>

			<div class="dotted-input-container">
				<span class="label">{{ labels.lbl_cockpit_reload_page }}</span>
				<select (change)="setReloadTimer($event.target.value)">
					<option [value]="300000">{{ labels.lbl_geral_selecione }}</option>
					<option [value]="60000" [selected]="searchConfig.cockpitReloadTime === 60000">1 {{ labels.lbl_geral_minuto }}</option>
					<option [value]="300000" [selected]="searchConfig.cockpitReloadTime === 300000">
						5 {{ labels.lbl_escalonamento_minutos }}
					</option>
					<option [value]="900000" [selected]="searchConfig.cockpitReloadTime === 900000">
						15 {{ labels.lbl_escalonamento_minutos }}
					</option>
					<option [value]="1800000" [selected]="searchConfig.cockpitReloadTime === 1800000">
						30 {{ labels.lbl_escalonamento_minutos }}
					</option>
					<option [value]="3600000" [selected]="searchConfig.cockpitReloadTime === 3600000">
						1 {{ labels.lbl_escalonamento_hora }}
					</option>
				</select>
			</div>
			<ng-container *ngIf="PermissionService.hasPermission('access_request')">
				<div class="label">
					<span>{{ labels.lbl_geral_periodo }}</span>
					<span class="tip">
						{{ labels.lbl_ckp_periodo_nao_aplicado_em_indicadores_concretos }}
					</span>
				</div>
				<div class="button-container mb-2">
					<div class="button" [ngClass]="{ selected: searchConfig.cockpitDateRange === '0' }" (click)="setSearchBase('0')">
						{{ labels.lbl_so_hoje }}
					</div>
					<div class="button" [ngClass]="{ selected: searchConfig.cockpitDateRange === '1' }" (click)="setSearchBase('1')">
						{{ labels.lbl_esse_mes }}
					</div>
					<!-- <div class="button" [ngClass]="{'selected' : searchConfig.cockpitDateRange === '2'}" (click)="setSearchBase('2')" *ngIf="ProfileService.userData().usertype.includes('manager.administrator')">{{labels.lbl_esse_ano}}</div> -->
					<div class="button" [ngClass]="{ selected: searchConfig.cockpitDateRange === '3' }" (click)="setSearchBase('3')">
						{{ labels.lbl_escalonamento_customizado }}
					</div>
				</div>

				<div class="dotted-input-container" *ngIf="searchConfig.cockpitDateRange === '3'">
					<span class="label">{{ labels.lbl_geral_data_inicial }}</span>
					<input type="date" [(ngModel)]="startDate" name="startDate" (change)="setCustomDate()" />
				</div>

				<div class="dotted-input-container" *ngIf="searchConfig.cockpitDateRange === '3'">
					<span class="label">{{ labels.lbl_geral_data_final }}</span>
					<input type="date" [(ngModel)]="endDate" name="endDate" (change)="setCustomDate()" />
				</div>
			</ng-container>

			<div class="dotted-input-container">
				<span class="label">{{ labels.lbl_reiniciar_cockpit }}</span>
				<div
					class="button"
					[ngClass]="{ disabled: isResetingCockpit }"
					(click)="confirmReset.classList.contains('confirmClick') ? restartCockpit() : confirmButton(confirmReset)"
					#confirmReset>
					<span>{{ labels.lbl_geral_reiniciar }}</span>
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isResetingCockpit"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
			<div class="dotted-input-container">
				<span class="label">{{ labels.lbl_filtros_disponiveis }}</span>
				<div class="button" (click)="showFilters = !showFilters">
					<cpi-dot-bounce-loading-effect *ngIf="!dataLoaded" [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
					<span *ngIf="dataLoaded">{{ labels.lbl_security_gerenciar }}</span>
				</div>
			</div>
		</div>

		<div class="body" *ngIf="showFilters && dataLoaded">
			<div class="group-header">{{ labels.lbl_filtros_disponiveis }}</div>
			<div class="group-body">
				<!-- <div *ngIf="this.cockpitFilters[0].indicatorFamily.length > 0">
            <cpi-generic-form-gen
            [setGenericForm]="filterIndicatorFamily"
            [columns]="1"
            [labels]="labels"
            [columns]="2">
            </cpi-generic-form-gen>
          </div> -->

				<div *ngIf="this.cockpitFilters[0].department.length > 0">
					<cpi-generic-form-gen [setGenericForm]="filterDepartment" [columns]="1" [labels]="labels" [columns]="2">
					</cpi-generic-form-gen>
				</div>
				<br />

				<div *ngIf="this.cockpitFilters[0].scope.length > 0">
					<cpi-generic-form-gen [setGenericForm]="filterScope" [columns]="1" [labels]="labels" [columns]="2">
					</cpi-generic-form-gen>
				</div>

				<div *ngIf="this.cockpitFilters[0].solutionArea.length > 0">
					<cpi-generic-form-gen [setGenericForm]="filterSolutionArea" [columns]="1" [labels]="labels" [columns]="2">
					</cpi-generic-form-gen>
				</div>
				<br />

				<div *ngIf="this.cockpitFilters[0].site.length > 0">
					<cpi-generic-form-gen [setGenericForm]="filterSite" [columns]="1" [labels]="labels" [columns]="2">
					</cpi-generic-form-gen>
				</div>
				<br />

				<div *ngIf="this.cockpitFilters[0].location.length > 0">
					<cpi-generic-form-gen [setGenericForm]="filterLocation" [columns]="1" [labels]="labels" [columns]="2">
					</cpi-generic-form-gen>
				</div>
				<br />

				<div *ngIf="this.cockpitFilters[0].customer.length > 1">
					<cpi-generic-form-gen [setGenericForm]="filterCustomer" [columns]="1" [labels]="labels" [columns]="2">
					</cpi-generic-form-gen>
				</div>

				<div class="button-container button-right distance-div">
					<div class="button" (click)="saveFilter()">
						<span>{{ labels.lbl_geral_salvar }}</span>
					</div>

					<div class="button" (click)="deleteFilter()">
						<span>{{ labels.lbl_reiniciar_filtros }}</span>
					</div>
				</div>
			</div>
		</div>

		<div
			class="evaluation-msp-modal evaluation-msp-modal-extremity-close"
			id="modalClose"
			(click)="modalClose($event, false)"
			*ngIf="isOpenModalEvaluationMSP">
			<div class="evaluation-msp-modal-content">
				<span class="evaluation-msp-modal-close" (click)="modalClose($event, true)"
					><fa-icon [icon]="icons.faXmark"></fa-icon
				></span>
				<app-mysupport-evaluation></app-mysupport-evaluation>
			</div>
		</div>

		<div class="loading-container" *ngIf="isLoadingLabels || isLoadingAvailableCharts">
			<cpi-svg-gears></cpi-svg-gears>
			<div>{{ labels.lbl_edocs_carregando }}!</div>
		</div>
	</div>
</div>
